export default {
  // Common
  'pages.common.operation': 'Operation',

  // FirmwarePackage
  'pages.firmwarePackage.pageTitle': 'Firmware Package Metadata',
  'pages.firmwarePackage.headerTitle':
    'Metadata is automatically written/updated after uploading OTA firmware; you can set the production default package and status here.',
  'pages.firmwarePackage.editModalTitle': 'Edit Firmware Package',
  'pages.firmwarePackage.fileRelPath': 'Relative Path',
  'pages.firmwarePackage.fileSize': 'Size',
  'pages.firmwarePackage.isProductionDefault': 'Production Default',
  'pages.firmwarePackage.isProductionDefaultLabel': 'Production default package (only one recommended per board type)',
  'pages.firmwarePackage.remark': 'Remark',
  'pages.firmwarePackage.saved': 'Saved',

  // OTAVersionPanel
  'pages.otaVersion.cardTitle': 'OTA Version Management',
  'pages.otaVersion.waitingServerResponse': 'Waiting for server response...',
  'pages.otaVersion.uploadFailedStatus': 'Upload failed ({status}): {detail}',
  'pages.otaVersion.networkError': 'Network error',
  'pages.otaVersion.uploadTimeout': 'Upload timed out',
  'pages.otaVersion.createSuccess': 'Device version created successfully',
  'pages.otaVersion.createFailed': 'Creation failed, please try again',
  'pages.otaVersion.versionCountLabel': '{count} version(s)',
  'pages.otaVersion.uploadProgress': 'Upload progress:',
  'pages.otaVersion.deviceNamePlaceholder': 'Filter by device name',
  'pages.otaVersion.deviceTypePlaceholder': 'Filter by device type',
  'pages.otaVersion.addDeviceVersion': 'Add Device Version',
  'pages.otaVersion.total': 'Total {total}',
  'pages.otaVersion.deviceTypeRequired': 'Please enter device type',
  'pages.otaVersion.deviceTypeExample': 'e.g. esp32-s3',
  'pages.otaVersion.deviceName': 'Device Name',
  'pages.otaVersion.noDeviceName': 'Unnamed',
  'pages.otaVersion.deviceType': 'Device Type',
  'pages.otaVersion.currentVersion': 'Firmware Version',
  'pages.otaVersion.noVersion': 'No version',
  'pages.otaVersion.historyVersions': 'History Versions',
  'pages.otaVersion.noHistoryVersions': 'No history versions',
  'pages.otaVersion.uploadFirmware': 'Upload Firmware',
  'pages.otaVersion.selectFile': 'Select File',
  'pages.otaVersion.delete': 'Delete',
  'pages.otaVersion.deleteConfirm': 'Confirm Deletion',
  'pages.otaVersion.deleteContent': 'Are you sure you want to delete this history version?',
  'pages.otaVersion.deleteSuccess': 'History version deleted successfully',
  'pages.otaVersion.deleteFailed': 'Failed to delete history version',
  'pages.otaVersion.fetchFailed': 'Failed to fetch version data',
  'pages.otaVersion.uploadSuccess': 'Firmware uploaded successfully',
  'pages.otaVersion.uploadFailed': 'Firmware upload failed',
  'pages.otaVersion.invalidFileName': 'Invalid file name format, must be xx.yy.zz.bin',
  'pages.otaVersion.fileTooLarge': 'File size cannot exceed 500MB',
  'pages.otaVersion.versionNotNewer': 'The uploaded version must be newer than the current latest version',
  // v2.3 rollout / rules
  'pages.otaVersion.rollout': 'Rollout Control',
  'pages.otaVersion.rules': 'Rule Management',
  'pages.otaVersion.ruleHelp': 'Rule usage: Blacklist = device never upgrades to this version; Whitelist (internal test) = only listed devices can upgrade to this version (others cannot). "All" matches every device. Note: even if a device is whitelisted, it must still hit the rollout percentage to be delivered — set a small non-zero rollout percentage as well.',
  'pages.otaVersion.uploadParams': 'Upload Firmware Options',
  'pages.otaVersion.uploadParamsNext': 'Next: Select File',
  'pages.otaVersion.format': 'Firmware Format',
  'pages.otaVersion.baseVersion': 'Base Version (required for diff)',
  'pages.otaVersion.baseVersionRequired': 'Base version is required for diff package',
  'pages.otaVersion.force': 'Force Upgrade',
  'pages.otaVersion.forceTag': 'Force',
  'pages.otaVersion.forceTip': 'When enabled, devices will upgrade regardless of version',
  'pages.otaVersion.forceNo': 'No',
  'pages.otaVersion.forceYes': 'Yes',
  'pages.otaVersion.versionPlaceholder': '1.0.0.0',
  'pages.otaVersion.baseVersionPlaceholder': 'e.g. 1.0.0',
  'pages.otaVersion.matchValuePlaceholder': 'MAC or serial',
  'pages.otaVersion.rolloutPercent': 'Initial Rollout Percent (%)',
  'pages.otaVersion.rolloutPercentTip': 'Upload enters draft status; adjust in Rollout Control',
  'pages.otaVersion.rolloutPercentRequired': 'Please enter rollout percent',
  'pages.otaVersion.releaseNote': 'Release Note',
  'pages.otaVersion.rolloutNeedId': 'This version lacks a firmware ID and cannot perform rollout',
  'pages.otaVersion.rolloutSuccess': 'Operation succeeded',
  'pages.otaVersion.rolloutFailed': 'Operation failed',
  'pages.otaVersion.rolloutStatus': 'Current Status',
  'pages.otaVersion.rolloutHelp': 'Rollout: controls release ratio by stable MAC hash. Publish/Adjust (1-99%)=rolling; 100%=full; Pause=temporarily freeze (already-delivered devices keep it, can resume by publishing again); Rollback=permanently stop delivering this version (devices fall back to old version).',
  'pages.otaVersion.rolloutAction': 'Action',
  'pages.otaVersion.rolloutActionRelease': 'Release / Adjust Percent',
  'pages.otaVersion.rolloutActionPause': 'Pause',
  'pages.otaVersion.rolloutActionFull': 'Full Release',
  'pages.otaVersion.rolloutActionRollback': 'Rollback',
  'pages.otaVersion.ruleMacTip': 'MAC addresses support both cases and various separators; system auto-normalizes (e.g. aa:bb:cc:dd:ee:ff ↔ AA:BB:CC:DD:EE:FF). Board-level (firmware_id=0) internal whitelist is disabled by default.',
  'pages.otaVersion.ruleType': 'Rule Type',
  'pages.otaVersion.ruleTypeBlack': 'Blacklist (Deny Upgrade)',
  'pages.otaVersion.ruleTypeWhite': 'Internal Release List',
  'pages.otaVersion.matchType': 'Match Type',
  'pages.otaVersion.matchSerial': 'Serial Number',
  'pages.otaVersion.matchAll': 'All',
  'pages.otaVersion.matchValue': 'Value',
  'pages.otaVersion.ruleAdd': 'Add',
  'pages.otaVersion.ruleNeedId': 'This version lacks a firmware ID and cannot configure rules',
  'pages.otaVersion.ruleAddSuccess': 'Rule added successfully',
  'pages.otaVersion.ruleAddFailed': 'Failed to add rule',
  'pages.otaVersion.ruleDeleteSuccess': 'Rule deleted successfully',
  'pages.otaVersion.ruleDeleteFailed': 'Failed to delete rule',
  'pages.otaVersion.ruleDeleteConfirm': 'Confirm delete this rule?',

  // OpsManage
  'pages.admin.ops.waitingServerResponse': 'Waiting for server response...',
  'pages.admin.ops.upload.successToast': 'Upload succeeded!',
  'pages.admin.ops.upload.failedStatus': 'Upload failed ({status}): {detail}',
  'pages.admin.ops.upload.networkError': 'Network error, upload failed',
  'pages.admin.ops.upload.timeout': 'Upload timed out, please try again',
  'pages.admin.ops.upload.canceled': 'Upload canceled',
  'pages.admin.ops.serverVersion': 'Server Version',
  'pages.admin.ops.rollbackVersion': 'Rollback Version',
  'pages.admin.ops.rollback.button': 'Rollback Service',
  'pages.admin.ops.rollback.confirmTitle': 'Caution: Are you sure you want to roll back the service?',
  'pages.admin.ops.rollback.desc': 'Rolling back the service will restore the previous version; data of the current version may be lost.',
  'pages.admin.ops.rollback.warn': 'This operation is irreversible. Please make sure important data has been backed up.',
  'pages.admin.ops.rollback.ok': 'Confirm Rollback',
  'pages.admin.ops.rollback.cancel': 'Cancel',
  'pages.admin.ops.rollback.success': 'Service rollback command sent',
  'pages.admin.ops.rollback.error': 'Service rollback failed',

  // Product
  'pages.products.deviceType.direct': 'Direct Device',
  'pages.products.deviceType.gatewaySub': 'Gateway Sub-device',
  'pages.products.deviceType.gateway': 'Gateway Device',
  'pages.products.locationType.ip': 'IP Location',
  'pages.products.locationType.deviceReport': 'Device Report',
  'pages.products.locationType.manual': 'Manual Location',
  'pages.products.netType.other': 'Other',
  'pages.products.rule.nameRequired': 'Please enter product name',
  'pages.products.rule.codecTypeRequired': 'Please enter codec type',
  'pages.products.rule.productKeyRequired': 'Please enter product key',
  'pages.products.rule.deviceTypeRequired': 'Please select device type',
  'pages.products.rule.locationTypeRequired': 'Please select location type',
  'pages.products.rule.netTypeRequired': 'Please select network type',
  'pages.products.addButton': 'Add Product',
  'pages.products.create.modal.categoryLabel': 'Product Category',
  'pages.products.card.id': 'ID',
  'pages.products.card.confirmDelete': 'Confirm deletion?',
  'pages.products.model.deviceTypeLabel': 'Device Type',
  'pages.products.model.locationTypeLabel': 'Location Type',
  'pages.products.model.netTypeLabel': 'Network Type',
  'pages.products.model.codecTypeLabel': 'Codec Type',
  'pages.products.save.success': 'Saved successfully',
  'pages.products.save.failed': 'Save failed',
  'pages.products.delete.success': 'Deleted successfully',
  'pages.products.delete.failed': 'Delete failed',

  // ProductCategory
  'pages.productCategory.rule.nameRequired': 'Please enter name',
  'pages.productCategory.rule.statusRequired': 'Please select status',
  'pages.productCategory.column.ID': 'ID',
  'pages.productCategory.column.ProductCategory.placeholder': 'Please select or search product device model',

  // ModelProviders
  'pages.admin.providers.typeCount': '{n}',

  // RecorderManage
  'pages.admin.recorder.recordCount': '({n})',

  // Settings
  'pages.admin.settings.llmOpenSource.label': 'LLM (open-source device default)',
  'pages.admin.settings.llmCommercial.label': 'LLM (commercial-license device default)',
  'pages.admin.settings.sameAsAbovePlaceholder': 'Same as the list above',
  'pages.admin.settings.llmOpenSource.optionCommercialSuffix': ' (requires commercial license, cannot be used as open-source default)',
  'pages.admin.settings.error.validation': 'Please fix form validation errors before saving',
  'pages.admin.settings.error.openSourceLlmCommercial': 'Open-source device default cannot select an LLM that requires a commercial license',

  // ContractDevicePanel
  'pages.contractDevice.macPattern': 'Please enter a valid MAC address',

  // SystemConfig page header / tabs / recharge / YAML
  'pages.systemConfig.pageTitle': 'System Configuration',
  'pages.systemConfig.pageSubtitle': 'Manage system configuration parameters',
  'pages.systemConfig.pageAlertTitle': 'Configuration Guide',
  'pages.systemConfig.pageAlertDesc':
    'Manage application, server, authentication and other settings here. Save promptly after changes.',
  'pages.systemConfig.tab.application': 'Application',
  'pages.systemConfig.tab.transport': 'Transport',
  'pages.systemConfig.tab.web': 'Web',
  'pages.systemConfig.tab.auth': 'Authentication',
  'pages.systemConfig.tab.roles': 'Roles',
  'pages.systemConfig.tab.localMcp': 'Local MCP',
  'pages.systemConfig.tab.externalMcp': 'External MCP',
  'pages.systemConfig.tab.exitCommands': 'Exit Commands',
  'pages.systemConfig.tab.log': 'Logging',
  'pages.systemConfig.tab.data': 'Data',
  'pages.systemConfig.tab.quickReply': 'Quick Reply',
  'pages.systemConfig.tab.recharge': 'Billing / Pay',
  'pages.systemConfig.tab.yaml': 'Full YAML (read-only)',
  'pages.systemConfig.quickReply.addWord': 'Add reply word',
  'pages.systemConfig.yaml.cardTitle': 'Full YAML (server_configs, read-only)',
  'pages.systemConfig.yaml.loadBtn': 'Load from server',
  'pages.systemConfig.yaml.placeholder': 'Click “Load from server” to view current config',
  'pages.systemConfig.recharge.cardTitle': 'Billing & WeChat Pay',
  'pages.systemConfig.recharge.enabled': 'Enable billing module',
  'pages.systemConfig.recharge.wechatPayDivider': 'WeChat Pay wechat_pay',
  'pages.systemConfig.recharge.wechatEnabled': 'Enable WeChat Pay',
  'pages.systemConfig.recharge.mchId': 'Merchant ID mch_id',
  'pages.systemConfig.recharge.apiV3Key': 'APIv3 key (leave blank or *** to keep)',
  'pages.systemConfig.recharge.certSerialNo': 'Merchant cert serial number',
  'pages.systemConfig.recharge.privateKeyPath': 'Merchant private key PEM path',
  'pages.systemConfig.recharge.notifyUrl': 'Payment notify_url',
  'pages.systemConfig.recharge.refundNotifyUrl': 'Refund notify_url (optional)',
  'pages.systemConfig.recharge.feeRate': 'Fee rate fee_rate',
  'pages.systemConfig.recharge.feeBearer': 'Fee bearer platform|user',
  'pages.systemConfig.recharge.wechatPublicKeyId': 'WeChat Pay public key ID',
  'pages.systemConfig.recharge.wechatPublicKeyPath': 'WeChat Pay public key PEM path',
  'pages.systemConfig.recharge.disableRefundOnSimFail': 'Do not auto-refund WeChat when IoT top-up fails',
  'pages.systemConfig.recharge.simPlatformsDivider': 'IoT platforms sim_platforms (JSON)',
  'pages.systemConfig.recharge.simPlatformsJson': 'Primary agent config object JSON',
  'pages.systemConfig.recharge.simPlatformsJsonInvalid': 'Must be a valid JSON object',
  'pages.systemConfig.websocketPlaceholder': 'ws://your-ip:8000',

  // Global error messages
  'helpers.systemName.fallback': 'Project Template',
  'helpers.error.loginFailed': 'Incorrect username or password',
  'helpers.error.unauthorized': 'Error: Not logged in or session expired. Please sign in again!',
  'helpers.error.tooManyRequests': 'Error: Too many requests. Please try again later!',
  'helpers.error.serverError': 'Error: Internal server error. Please contact the administrator!',
  'helpers.error.prefix': 'Error: ',
  'helpers.error.demoOnly': 'This site is for demo only; no backend available!',
  'helpers.error.requestFailed': 'Request failed!',

  // Service-layer user-visible errors
  'pages.admin.providers.error.updateParams': 'Both type and name are required when updating a provider',
  'pages.admin.providers.error.deleteParams': 'Both type and name are required when deleting a provider',
  'pages.admin.providers.error.testParams': 'Both type and name are required when testing a provider',
  'pages.admin.providers.error.toggleParams': 'Both type and name are required when toggling a provider',
  'pages.admin.providers.error.invalidType': 'Invalid provider type: {type}. Valid types: {validTypes}',
  'pages.knowledgeBase.error.noTaskId': 'Upload accepted but no task ID returned. Refresh the list and retry.',
  'pages.knowledgeBase.error.indexFailed': 'Document indexing failed',
  'pages.knowledgeBase.error.processTimeout': 'Document processing timed out. Check status in the document list later.',
};
